/**
 * 获取环境变量
 * @param  {String} ua navigator.userAgent
 * @return {Object} 包含各种环境判断的 UA
 */
let ua = (function (useragent) {
  if (useragent) {
    return {
      isMobile: /AppleWebKit.*Mobile.*/gi.test(useragent), // 是否移动设备
      isIOS: /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(useragent), // 是否 iOS
      isAndroid: useragent.indexOf('Android') > -1 || useragent.indexOf('Linux') > -1, // 是否 Android
      isWeixin: useragent.indexOf('MicroMessenger') > -1, // 是否微信
      isMini: (function isMini() {
        // 是否小程序
        return window.__wxjs_environment === 'miniprogram'
      })(),
      isFsPlus: false
    }
  }
})(navigator.userAgent)
export default ua
